// src/utils/whatsappOrderMessages.js

export const buildOrderConfirmationWhatsAppMessage = (order) => {
  const firstName = order.customer?.name?.split(" ")[0] || "Customer";

  const discountAmount = Number(order.discount || 0);

  const itemsText = order.items
    .map(
      (i) =>
        `- ${i.title_en}\n  Qty: ${i.quantity} x $${i.price} = $${(
          i.quantity * i.price
        ).toFixed(2)}`
    )
    .join("\n");

  const extraFee =
    Number(order.extraFeeAmount || 0) > 0
      ? `\nExtra fees (${order.extraFeeLabel || "Fee"}): $${Number(
          order.extraFeeAmount
        ).toFixed(2)}`
      : "";

  const shippingText =
    order.shippingMethod === "pickup"
      ? "Pickup from store (Free)"
      : order.shippingCost === 0
      ? "Free delivery"
      : `Delivery: $${order.shippingCost.toFixed(2)}`;

  const addressText =
    order.shippingMethod === "pickup"
      ? "Pickup from LIONS main store"
      : [
          order.customer.governorate,
          order.customer.area,
          order.customer.street,
          order.customer.building,
        ]
          .filter(Boolean)
          .join(" - ");

  const message = `
*LIONS STORE*

Hello ${firstName},

Your order *#${order.orderNumber}* has been confirmed and shipped.

----------------------
ORDER DETAILS
----------------------
${itemsText}

----------------------
PAYMENT SUMMARY
----------------------
Subtotal: $${order.subtotal.toFixed(2)}
${discountAmount > 0 ? `Discount: $${discountAmount.toFixed(2)}` : ""}
${shippingText}${extraFee}
TOTAL: $${order.total.toFixed(2)}

----------------------
DELIVERY INFO
----------------------
${addressText}

Thank you for choosing *LIONS*.
We appreciate your trust.

LIONS Team
  `.trim();

  return encodeURIComponent(message);
};
